import React from 'react'
import { string } from 'prop-types'
import styled from 'styled-components'
import { Row, Col } from 'reactstrap'

export const StagesCardWrapper = styled.div`
  display: flex;
  position: relative;
  justify-content: flex-start;
  border-bottom: 5px dashed #ebe3d5;
  padding: 30px 0;
  @media (max-width: 992px) {
    flex-wrap: wrap;
  }
`

export const Heading = styled.h3`
  font-weight: 800;
  line-height: 1;
  margin-bottom: 20px;
  font-size: 28px;
  color: ${p => p.color || p.theme.colors.gold};
  @media screen and (min-width: 1025px) {
    font-size: 54px;
    margin-bottom: 12px;
  }
  span {
    font-size: 70px;
  }
`

export const StepImg = styled.img`
  box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.2);
  max-width: 100%;
  margin: 0 auto 40px;
  display: block;
  @media screen and (min-width: 1025px) {
    margin: 0 auto;
    max-width: 80%;
  }
`

export const Icon = styled.img`
  max-width: 30px;
  max-height: 30px;
  vertical-align: baseline;
  @media screen and (min-width: 1025px) {
    max-width: 60px;
    max-height: 60px;
  }
`

export const RowMiddle = styled(Row)`
  align-items: center;
  flex-direction: ${props => {
    console.log(props)
    return props.reversed ? 'row-reverse' : 'row'
  }};
  padding-top: 2em;
  padding-bottom: 2em;
`

export const Paragraph = styled.div`
  font-size: 16px;
  color: ${p => p.color || p.theme.colors.darkGray};
  @media screen and (min-width: 1025px) {
    font-size: 28px;
    margin-bottom: 12px;
  }
`

const StepsCard = props => {
  return (
    <StagesCardWrapper>
      <RowMiddle reversed={props.reverse}>
        <Col md={{ size: 4 }}>
          <a href={props.image}>
            <StepImg src={props.image} />
          </a>
        </Col>
        {props.image2 ? (
          <Col md={{ size: 4 }}>
            <a href={props.image}>
              <StepImg src={props.image2} />
            </a>
          </Col>
        ) : (
          ''
        )}
        {props.image2 ? (
          <Col md={{ size: 4 }}>
            <Heading>
              {props.icon ? <Icon src={props.icon} /> : ''} {props.title}
            </Heading>
            <Paragraph>{props.text}</Paragraph>
          </Col>
        ) : (
          <Col md={{ size: 8 }}>
            <Heading>
              {props.icon ? <Icon src={props.icon} /> : ''} {props.title}
            </Heading>
            <Paragraph>{props.text}</Paragraph>
          </Col>
        )}
      </RowMiddle>
    </StagesCardWrapper>
  )
}

StepsCard.propTypes = {
  image: string,
  number: string,
  title: string.isRequired,
  text: string.isRequired
}

export default StepsCard
